module.exports = __webpack_public_path__ + "img/SamsungGalaxyTab8A.e007c1a1.jpeg";